import { DynamicValue } from "@faedev/dynamic-values";
import { useRouter } from "next/router";
import {
  FiltersState,
  filtersToQuery,
  queryToFilters,
} from "src/components/Filter";

export function useFilters(
  defaultFilterValues: Partial<FiltersState> = {}
): DynamicValue<FiltersState> {
  var { query, push } = useRouter();
  return new DynamicValue(
    queryToFilters(query, defaultFilterValues),
    (newFilter) => {
      push({
        // pathname: '/post/[pid]',
        query: filtersToQuery(newFilter),
      });
    }
  );
}
